const SEOUL_TIME_ZONE = 'Asia/Seoul'

export function formatTextbookRequestDate(value: string | null) {
  if (!value) return '-'

  return new Date(value).toLocaleString('ko-KR', {
    timeZone: SEOUL_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  })
}

/** 해피데이 당일 출고 접수 마감 시각(Asia/Seoul 기준, 시). 이 시각 이후 요청은 다음 영업일로 잡는다. */
export const HAPPYDAY_SAME_DAY_CUTOFF_HOUR = 16

function seoulWallClock(now: Date) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: SEOUL_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(now)
  const read = (type: Intl.DateTimeFormatPartTypes) =>
    Number(parts.find((part) => part.type === type)?.value ?? '0')
  return { year: read('year'), month: read('month'), day: read('day'), hour: read('hour') }
}

function isWeekendUtc(date: Date) {
  return date.getUTCDay() === 0 || date.getUTCDay() === 6
}

function toDateInputUtc(date: Date) {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * 센터 출고일 기본값. 한국 시각 16시 이전이면 당일, 이후면 다음 날.
 * 주말은 건너뛰어 다음 영업일(월~금)로 맞춘다. 브라우저 시간대에 의존하지 않는다.
 */
export function defaultHappydayOutDate(now: Date = new Date()) {
  const seoul = seoulWallClock(now)
  const candidate = new Date(Date.UTC(seoul.year, seoul.month - 1, seoul.day))
  if (seoul.hour >= HAPPYDAY_SAME_DAY_CUTOFF_HOUR) {
    candidate.setUTCDate(candidate.getUTCDate() + 1)
  }
  while (isWeekendUtc(candidate)) {
    candidate.setUTCDate(candidate.getUTCDate() + 1)
  }
  return toDateInputUtc(candidate)
}
